export default __webpack_public_path__ + "static/media/lipstick-dark-winter.5f6f1b56.png";